import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import Type from '@nerdwallet/react-typography';
import Link from '@nerdwallet/react-link';

const PressInquiries = () => (
  <section
    className={classNames([
      'press-inquiries',
      classes('width-100'),
      classes('margin-all-0'),
      classes('padding-top-5'),
      classes('padding-bottom-4'),
      classes('padding-horizontal-4'),
      classes('background-white'),
      classes('text-align-center'),
    ])}
  >
    <Type
      component="h2"
      size="2"
      bold
      className={classNames([classes('margin-bottom-3')])}
    >
      Media inquiries
    </Type>
    <ul
      className={classNames([
        'press-inquiries__contact',
        classes('margin-bottom-5'),
        classes('margin-horizontal-auto'),
        classes('padding-all-0'),
      ])}
    >
      <li>
        <Type size="2">press@nerdwallet.com</Type>
      </li>
      <li
        className={classNames([
          'press-inquiries__separator',
          classes('display-none'),
        ])}
      >
        <Type size="2">|</Type>
      </li>
      <li>
        <Type size="2">awards@nerdwallet.com</Type>
      </li>
      <li
        className={classNames([
          'press-inquiries__separator',
          classes('display-none'),
        ])}
      >
        <Type size="2">|</Type>
      </li>
      <li>
        <Type size="2">(415) 612-2534</Type>
      </li>
    </ul>
    <Type
      component="h2"
      size="2"
      bold
      className={classNames([classes('margin-bottom-3')])}
    >
      Press kit
    </Type>
    <Type
      component="h2"
      size="2"
      className={classNames([classes('margin-bottom-3')])}
    >
      If you&apos;d like to feature NerdWallet, we&apos;ve created some
      guidelines to help you use our brand and assets.
    </Type>
    <Link href="/kit">
      <Type component="h2" size="2">
        View press kit
      </Type>
    </Link>
  </section>
);

PressInquiries.displayName = 'PressInquiries';

export default PressInquiries;
